import { StateUtils } from '@spartacus/core';
import { ORDERS, ORDER_DETAILS } from '@spartacus/order/core';
import { OrdersFilter } from '../../../../model/order-filters.model';
import { OrderStatusList } from '../../../../model/order-status-list.model';
import { LoaderLoadAction } from '../../../state/utils/loader/loader.action';

export const CUSTOM_LOAD_USER_ORDERS = '[User] Custom Load User Orders';
export const CUSTOM_LOAD_USER_ORDER_DETAILS = '[User] Custom Load User Order Details';

export const USER_ORDERS_STATUS = '[User] User Orders Status';
export const LOAD_USER_ORDERS_STATUS = '[User] Custom Load User Orders Status';
export const LOAD_USER_ORDERS_STATUS_SUCCESS = '[User] Custom Load User Orders Status Success';
export const LOAD_USER_ORDERS_STATUS_FAIL = '[User] Custom Load User Orders Status Fail';

export class CustomLoadUserOrders extends StateUtils.LoaderLoadAction {
  readonly type = CUSTOM_LOAD_USER_ORDERS;

  constructor(
    public payload: {
      userId: string;
      pageSize?: number;
      currentPage?: number;
      sort?: string;
      replenishmentOrderCode?: string;
      ordersFilter?: OrdersFilter;
    }
  ) {
    super(ORDERS);
  }
}

export class LoadUserOrdersStatus extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_USER_ORDERS_STATUS;

  constructor() {
    super(USER_ORDERS_STATUS);
  }
}

export class LoadUserOrdersStatusSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_USER_ORDERS_STATUS_SUCCESS;

  constructor(public payload: OrderStatusList) {
    super(USER_ORDERS_STATUS);
  }
}

export class LoadUserOrdersStatusFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_USER_ORDERS_STATUS_FAIL;

  constructor(public payload: { error: any }) {
    super(USER_ORDERS_STATUS, payload.error);
  }
}

export class CustomLoadOrderDetails extends LoaderLoadAction {
  readonly type = CUSTOM_LOAD_USER_ORDER_DETAILS;

  constructor(
    public payload: {
      userId: string;
      orderCode: string;
    }
  ) {
    super(ORDER_DETAILS);
  }
}

export type CustomUserOrdersAction = CustomLoadUserOrders | LoadUserOrdersStatus | LoadUserOrdersStatusSuccess | LoadUserOrdersStatusFail | CustomLoadOrderDetails;
